<template>
  <Grid />
</template>
<script>
import Grid from './components/grid'
export default {
  name: 'ecom-approval-center-todo',
  components: { Grid },
}
</script>
